import { render, staticRenderFns } from "./Extension.vue?vue&type=template&id=1c7e67c6&scoped=true"
import script from "./Extension.vue?vue&type=script&lang=js"
export * from "./Extension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7e67c6",
  null
  
)

export default component.exports